<template>
  <modal height="auto" width="610px" :scrollable="true" adaptive name="channel-add-edit-modal" @before-open="beforeOpen" @before-close="beforeClose">
    <header class="modal__header">
      <template v-if="id">
        Edit Channel
      </template>
      <template v-else>
        Add Channel
      </template>
      <i class="fas fa-times" @click="$modal.hide('channel-add-edit-modal')"></i>
    </header>
    <main class="modal__body">
      <div>
        <rum-label>
          Feature
        </rum-label>
        <rum-toggle-button v-model="feature" :options="featureTypes"></rum-toggle-button>
      </div>
      <rum-label class="modal-body__label">
        Name
        <i class="tooltip-icon fas fa-question-circle" v-tooltip="'The name of the channel as shown to your Learners in the Menu and as the Title.'"></i>
      </rum-label>
      <rum-input placeholder="Channel Name" v-model="channel.name" :maxlength="18" />

      <rum-label class="modal-body__label">
        Action
        <i class="tooltip-icon fas fa-question-circle" v-tooltip="'The action text that best describes this page ex. Build a business'"></i>
      </rum-label>
      <rum-input placeholder="Action" v-model="channel.action" :maxlength="40" />

      <rum-label class="modal-body__label">
        Description
        <i class="tooltip-icon fas fa-question-circle" v-tooltip="'The description of this channel page to your Learners shown at the top.'"></i>
      </rum-label>
      <rum-textarea  placeholder="Channel Description" v-model="channel.description" />

      <rum-label class="modal-body__label">
        Filters
        <i class="tooltip-icon fas fa-question-circle" v-tooltip="'Criteria upon which Bytes will be included. Select an Organization/Author by typing @, or a Tag with #'"></i>
      </rum-label>
      <rum-select
        placeholder="Select an Organization/Author by starting with @, or a Tag with #"
        v-model="selectedFilters"
        :options="filtersList"
        :clearable="false"
        class="partners__filter"
        label="name"
        @search="searchThrottled"
        multiple
        push-tags
      />
    </main>
    <footer class="modal__footer">
      <rum-icon-input :recommendations="recommendations" v-model="channel.icon" />
      <div class="channel__action" v-if="id && !working">
        <rum-button class="channel-action__delete" @click="confirmChannelDelete" tertiary>Delete Channel</rum-button>
        <rum-button @click="editChannel">Update Channel</rum-button>
      </div>
      <div class="channel__action channel__action--add" v-else>
        <rum-button v-if="!working"  @click="addChannel">Add Channel</rum-button>
      </div>
      <rum-loader v-if="working" class="people-card__loader" center/>
    </footer>
    <v-dialog />
  </modal>
</template>

<script>
import api from "@/api";
import isNil from "lodash/isNil";
import throttle from "lodash/throttle";
import {
  FEATURE_TYPES
} from "@/utils/project";

export default {
  data() {
    return {
      featureTypes: FEATURE_TYPES,
      feature: FEATURE_TYPES[0].value,
      id: null,
      selectedFilters: [{
        "name": "@Rumie",
        "id": "5126e2ec-ae11-473e-9fe8-5afcbb70aa7f",
        "type": "org"
      }],
      filtersList: [],
      working: false,
      channel: {
        name: "",
        description: "",
        action: "",
        icon: {
          code: "far fa-books",
          color: "#8795a1",
          name: "books",
          style: "far",
          unicode: "f5db",
        }
      },
      recommendations: ["far fa-books","far fa-atlas","far fa-book-spells","far fa-users-class","far fa-users","far fa-layer-group"],
    };
  },
  computed: {
    creating() {
      return !this.id;
    },
    projectId() {
      return this.$route.params.id;
    },
  },
  methods: {
    beforeClose() {
      this.id = null;
      this.channel.name = null;
      this.channel.description = null;
      this.working = false;
      this.channel.icon.code = "far fa-books";
      this.channel.icon.color = "#8795a1";
      this.channel.icon.style = "far";
      this.channel.icon.name = "books";
      this.channel.icon.unicode = "f5db";
      this.feature = 0;
      this.channel.action = null;
      this.filtersList = [];
      this.selectedFilters = [{
        "name": "@Rumie",
        "id": "5126e2ec-ae11-473e-9fe8-5afcbb70aa7f",
        "type": "org"
      }];
    },
    beforeOpen(event) {
      const channel = event.params && event.params.channel;
      if (!channel) return;

      this.id = channel.id;
      this.working = false;
      this.channel.name = channel.name;
      this.channel.description = channel.description;
      this.feature = channel.feature;
      this.channel.action = channel.action;
      let channelIcon = JSON.parse(channel.icon);
      if(!isNil(channelIcon.color)) {
        this.channel.icon.color = channelIcon.color;
        this.channel.icon.code = channelIcon.code;
        this.channel.icon.unicode = channelIcon.unicode;
        this.channel.icon.name = channelIcon.name;
        this.channel.icon.style = channelIcon.style;
      }
      this.filtersList = this.filterArrivingFormat(channel.filter);
      this.selectedFilters = this.filtersList;
    },
    filterArrivingFormat(filters) {
      let orgs = [];
      if(filters.orgs.length > 0) {
        orgs = filters.orgs.map(org=> {
          return {...org, "type":"org", "name": `@${org.name}`}
        })
      }
      let tags = [];
      if(filters.tags.length > 0) {
        tags = filters.tags.map(tag=> {
          return {...tag, "type":"tag", "name": `#${tag.name}`}
        })
      }
      let authors = [];
      if(filters.authors.length > 0) {
        authors = filters.authors.map(author=> {
          return {...author, "type":"author", "name": `@${author.name}`}
        })
      }
      let filterFormat = [];
      if(filters.filterIdentifier) {
        if(filters.filterIdentifier === "@") {
          return filterFormat.concat(orgs, authors);
        } else if(filters.filterIdentifier === "#") {
          return filterFormat.concat(tags);
        }
      } else {
        return filterFormat.concat(orgs, tags, authors);
      }
    },
    filterSendingFormats(filters) {
      let filteredFormat = filters.map(filter => {
        return {"type": filter.type, "id": filter.id}
      })
      return filteredFormat;
    },
    searchThrottled: throttle(function(search, loading) {
      this.searchFilters(search, loading);
    }, 2500),
    async searchFilters(search, loading) {
      loading(true);
      try {
        let filterIdentifier = '';
        const current = api('v3');
        if(search.charAt(0) === '@' || search.charAt(0) === '#' ) {
          filterIdentifier = search.charAt(0);
          search = search.substring(1)
        }
        if(search) {
          const { data } = await current.get(`connect/projects/${this.projectId}/channels/search_filter?query=${search}`);
          if (!data) return;
          this.filtersList = this.filterArrivingFormat({...data, 'filterIdentifier': filterIdentifier});
        }
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message;
        this.$notify({
          type: "error",
          title: errorMessage || "Failed to fetch filters, please try again."
        });
      } finally {
        loading(false);
      }
    },
    async addChannel() {
      try {
        this.working = true;
        const current  = api('v3');
        await current.post(`connect/projects/${this.projectId}/channels`, {
          name: this.channel.name,
          description: this.channel.description,
          icon: JSON.stringify(this.channel.icon),
          filter: JSON.stringify(this.filterSendingFormats(this.selectedFilters)),
          sort: 0,
          feature: this.feature,
          action: this.channel.action
        });
        this.$modal.hide("channel-add-edit-modal");
        this.$emit('refresh');
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message;
        this.$notify({
          type: "error",
          title: errorMessage || "Failed to add channel, please try again."
        });
      } finally {
        this.working = false;
      }
    },
    async editChannel() {
      try {
        this.working = true;
        const current  = api('v3');
        await current.post(`connect/projects/${this.projectId}/channels/${this.id}`, {
          name: this.channel.name,
          description: this.channel.description,
          icon: JSON.stringify(this.channel.icon),
          filter: JSON.stringify(this.filterSendingFormats(this.selectedFilters)),
          feature: this.feature,
          action: this.channel.action
        });
        this.$modal.hide("channel-add-edit-modal");
        this.$emit('refresh');
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message;
        this.$notify({
          type: "error",
          title: errorMessage || "Failed to edit channel, please try again."
        });
      } finally {
        this.working = false;
      }
    },
    confirmChannelDelete() {
      this.$modal.show("dialog", {
        title: "Delete Channel",
        text: `Are you sure you want to delete channel ${this.channel.name}?`,
        buttons: [
          {
            title: "Yes",
            handler: async () => {
              try {
                this.working = true;
                const current  = api('v3');
                await current.delete(`connect/projects/${this.projectId}/channels/${this.id}`);
                this.$notify({
                  type: "success",
                  title: "Channel has deleted successfully."
                });
                this.$modal.hide("dialog");
                this.$modal.hide("channel-add-edit-modal");
                this.$emit('refresh');
              }
              catch(error) {
                  console.log(error);
                  const errorMessage = error.response.data.message;
                  this.$notify({
                  type: "error",
                  title: errorMessage || "Failed to delete channel."
                });
              } finally {
                this.working = false;
              }
            }
          },
          {
            title: "No",
            handler: () => this.$modal.hide("dialog")
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
.project-form__row {
  margin-bottom: var(--spacing-4);
}
.modal-body__label {
  padding-top: var(--spacing-4);
}

.modal-body__checkbox {
  padding-top: var(--spacing-2);
}

.modal-body__icon {
  margin-top: var(--spacing-8);
}

.modal-footer__action {
  display: flex;
  justify-content: space-between;
}

.modal-footer__button {
  margin-bottom: var(--spacing-3);
}

.channel-action__delete {
  color: var(--red) !important;
  border-color: var(--red) !important;
}

.channel__action {
  display: flex;
  justify-content: space-between;
  margin-top: var(--spacing-6);
}

.channel__action--add {
  justify-content: flex-end;
}

.modal__body, .modal__footer {
  padding: var(--spacing-8) var(--spacing-6);
}

.modal__footer {
  padding-top: 0;
}
</style>
